import { render, staticRenderFns } from "./sectionSmallPortfolio.vue?vue&type=template&id=582ed9ea&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sectionSmallPortfolio.vue"
export default component.exports